export default __webpack_public_path__ + "static/media/Debug_Icon.7da730d9.svg";